"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollLeftPrevCustom = exports.scrollLeftNextCustom = exports.scrollLeftDirection = void 0;

const scrollLeftDirection = () => {
  document.body.insertAdjacentHTML('beforeend', "<div style='direction: rtl;\
       position: absolute; left: 0; top: 0; overflow: hidden; width: 1px;\
       height: 1px;'><div style='width: 2px; height: 1px;'></div></div>");
  const scroller = document.body.lastElementChild;
  const initially_positive = scroller.scrollLeft > 0;
  scroller.scrollLeft = -1;
  const has_negative = scroller.scrollLeft < 0;
  const result = {
    decreasing: has_negative || initially_positive,
    nonpositive: has_negative
  };
  document.body.removeChild(scroller);

  if (result.decreasing && result.nonpositive) {
    return 'negative';
  } else if (result.decreasing && !result.nonpositive) {
    return 'reversed';
  }

  return 'positive';
};

exports.scrollLeftDirection = scrollLeftDirection;

const scrollLeftNextCustom = (rtl, rtlScrollType, target, container) => {
  if (!rtl) return target.offsetLeft;

  switch (rtlScrollType) {
    case 'negative':
      return target.offsetLeft - container.offsetWidth + target.getBoundingClientRect().width;

    case 'reversed':
      return container.scrollWidth - 2 * container.offsetWidth + target.offsetLeft + target.getBoundingClientRect().width;

    default:
      return container.offsetWidth - target.offsetLeft - target.getBoundingClientRect().width;
  }
};

exports.scrollLeftNextCustom = scrollLeftNextCustom;

const scrollLeftPrevCustom = (rtl, rtlScrollType, target, container) => {
  if (!rtl) return target.offsetLeft + target.getBoundingClientRect().width - container.offsetWidth;

  switch (rtlScrollType) {
    case 'negative':
      return target.offsetLeft;

    case 'reversed':
      return container.scrollWidth - container.offsetWidth + target.offsetLeft;

    default:
      return -target.offsetLeft;
  }
};

exports.scrollLeftPrevCustom = scrollLeftPrevCustom;